<template>
    <el-container :class="isMobile">
        <el-main type="flex">
            <slot>
            </slot>
        </el-main>
    </el-container>
</template>

<script>
export default {
    data: function() {
        return {};
    },
    components: {},
    beforeMount() {
    },
    computed: {
        isMobile() {
            return {
                mobile: window.innerWidth < this.$root.desktopWidth
            };
        }
    }
};
</script>

<style lang="scss">
    html, body {
        height: 100%;
        padding: 0;
        margin: 0;
    }
    #app {
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }
</style>
